import React from 'react';
import { createPortal } from 'react-dom';
import '../../styles-wa/confirmation_modals.css';

export const ArchiveConfirmModal = ({
  isOpen,
  templateName,
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="wa-module">
      <div className="confirm-overlay">
        <div className="confirm-modal archive-confirm">
          <div className="confirm-icon archive-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="21 8 21 21 3 21 3 8" />
              <line x1="1" y1="3" x2="23" y2="3" />
              <path d="M10 12v5M14 12v5" />
            </svg>
          </div>

          <h3 className="confirm-title">Archive Template?</h3>
          <p className="confirm-message">
            <strong>{templateName}</strong> will be archived and hidden from your active templates.
            You can restore it later.
          </p>

          <div className="confirm-footer">
            <button
              className="confirm-btn-secondary"
              onClick={onCancel}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              className="confirm-btn-primary archive-btn"
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? 'Archiving...' : 'Archive Template'}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export const DeleteConfirmModal = ({
  isOpen,
  templateName,
  itemName = templateName,
  title = "Delete Template?",
  message = "will be permanently deleted. This action cannot be undone.",
  confirmText = "Delete Template",
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="wa-module">
      <div className="confirm-overlay">
        <div className="confirm-modal delete-confirm">
          <div className="confirm-icon delete-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
              <line x1="10" y1="11" x2="10" y2="17" />
              <line x1="14" y1="11" x2="14" y2="17" />
            </svg>
          </div>

          <h3 className="confirm-title">{title}</h3>
          <p className="confirm-message">
            {itemName && <strong>{itemName} </strong>}
            {message}
          </p>

          <div className="confirm-footer">
            <button
              className="confirm-btn-secondary"
              onClick={onCancel}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              className="confirm-btn-primary delete-btn"
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? 'Deleting...' : confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};



